import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'
const prefix = localDev ? '' : requestPrefix.projectUrl
export default {
  // 访客登记
  saveProjectVisitor(data) {
    return Axios({
      url: prefix + '/projectVisitor/saveVisitor',
      method: 'post',
      data: data
    })
  },
  // 访客登记
  getProjectVisitCarLog(data) {
    return Axios({
      url: prefix + '/projectVisitor/getCarNo',
      method: 'get',
      params: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/visitor/index.js